import React, { useState } from "react";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import useSWR from "swr";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import "./location_code_rack.css";

const fetcher = (url: string) => axios.get(url).then((res) => res.data);
interface RackLocationRecord { id: number; code_rack: string; name_rack: string; status: string; }
interface LocationCodeRackProps {
    onSelectRack: (code_rack: string) => void;
}
const LocationCodeRack: React.FC<LocationCodeRackProps> = ({ onSelectRack }) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const { userData } = useAuth();
    const warehouseCode = userData?.warehouse_code || "";

    const [searchText, setSearchText] = useState("");
    const [sortField, setSortField] = useState("code_rack");
    const [sortOrder, setSortOrder] = useState<SortOrder>("ascend");

    const queryParams = new URLSearchParams({
        warehouse_code: warehouseCode,
        search: searchText,
        sortField,
        sortOrder: sortOrder || "",
    });

    const { data, isLoading } = useSWR(
        warehouseCode ? `${process.env.REACT_APP_BACKEND_URL}/api/spareparts/rack-locations?${queryParams.toString()}` : null,
        fetcher
    );

    const handleSearch = (selectedKeys: string[], confirm: () => void) => {
        confirm();
        setSearchText(selectedKeys[0] || "");
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText("");
    };

    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        if (sorter && sorter.field) {
            setSortField(sorter.field);
            setSortOrder(sorter.order || "ascend");
        }
    };

    const columns: ColumnsType<RackLocationRecord> = [
        {
            title: "Location Code Rack",
            dataIndex: "code_rack",
            key: "code_rack",
            sorter: true,
            sortOrder: sortField === "code_rack" ? sortOrder : undefined,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder="Search Location Code Rack"
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                        style={{ width: 188, marginBottom: 8, display: "block" }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys as string[], confirm)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Search
                        </Button>
                        <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
            ),
        },
    ];


    return (

        <div id="intg" style={transformStyle}>
            <div className="gjs-grid-row" id="it2bh">
                <div className="gjs-grid-column" id="idq4g">
                    <Table<RackLocationRecord>
                        rowKey="id"
                        dataSource={data || []}
                        columns={columns}
                        loading={isLoading}
                        onChange={handleTableChange}
                        onRow={(record) => ({
                            onDoubleClick: () => onSelectRack(record.code_rack),
                        })}
                    />
                </div>
            </div>
        </div>
    );
};

export default LocationCodeRack; 
